import {
  templateOverridesListSlice,
  templateOverridesLoadingSlice,
} from '../slices';

import { FronteggContext } from '@frontegg/rest-api';
import { showToastError } from 'src/utilities/errortoast';
import { showToastSuccess } from 'src/utilities/toast';
import { axiosAmbient } from 'src/lib/axios';
import { Axios } from 'src/lib';
import { AxiosAmbient } from '../../../../lib';
import { axiosAdmin } from '../../../../lib/axios';

export const listTemplateOverridesOrgs = (org_uuid) => {
  return async (dispatch) => {
    dispatch(templateOverridesLoadingSlice(true));
    dispatch(templateOverridesListSlice([]));
    const headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${FronteggContext.getAccessToken()}`,
      'Impersonate-Org-UUID': `${org_uuid}`,
      'Headless-Mode': true,
    };
    const result = await AxiosAmbient.get(`/get_all_template_overrides`, {
      headers,
    });
    const response = result?.data;
    if (result?.status === 200) {
      dispatch(templateOverridesListSlice(response.templates));
    } else {
      showToastError('Failed to load templates');
    }
    dispatch(templateOverridesLoadingSlice(false));
  };
};

export const pushTemplateOverrides = (
  template_overrides,
  orgs,
  practitionerMap,
  setSelectedOrganizations,
  setSelectedPractitioners,
  onSuccessCallback,
  isSuperAdmin = true
) => {
  return async () => {
    const headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${FronteggContext.getAccessToken()}`,
    };
    let final_payload = {};
    for (const org_uuid of orgs) {
      if (practitionerMap[org_uuid]?.length > 0) {
        final_payload[org_uuid] = practitionerMap[org_uuid];
      } else {
        final_payload[org_uuid] = [];
      }
    }
    const payload = {
      template_overrides_data: template_overrides,
      org_practitioner_data: final_payload,
    };
    const result = isSuperAdmin
      ? await axiosAdmin.post(`/template-management/assign`, payload, {
          headers,
        })
      : await Axios.post(`/v2/assign_templates`, payload, {
          headers,
        });
    if (result?.status === 200) {
      showToastSuccess('Templates pushed successfully');
      setSelectedOrganizations([]);
      setSelectedPractitioners([]);
      onSuccessCallback();
    } else {
      showToastError('Failed to push templates');
    }
  };
};

export const createInsightHealthTemplatesAction = (template_overrides) => {
  return async () => {
    const headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
      Authorization: `Bearer ${FronteggContext.getAccessToken()}`,
      'Headless-Mode': true,
    };

    const data = {
      template_overrides_data: template_overrides,
    };

    const result = await axiosAmbient.post(`/insight_health_templates`, data, {
      headers,
    });

    if (result?.status === 200) {
      showToastSuccess('Templates pushed successfully');
      return true;
    } else {
      showToastError('Failed to push templates');
      return false;
    }
  };
};
